import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["status", "statusDot", "enableButton", "additionalInfo"]
  static values = { vapidKey: String }

  connect() {
    this.updateStatus()
  }

  async requestPermission() {
    if (!("Notification" in window)) {
      this.updateStatus("not-supported", "Pregljednik ne podržava obavijesti")
      return
    }

    if (Notification.permission === "granted") {
      this.enableNotifications()
    } else if (Notification.permission !== "denied") {
      // Update button to show loading state
      if (this.hasEnableButtonTarget) {
        this.enableButtonTarget.disabled = true
        this.enableButtonTarget.innerHTML = `
          <div class="spinner-border spinner-border-sm me-2" role="status"></div>
          Molimo dozvolite...
        `
      }

      const permission = await Notification.requestPermission()
      if (permission === "granted") {
        this.enableNotifications()
      } else if (permission === "denied") {
        this.updateStatus("denied", "Obavijesti su odbačene")
      }
    } else {
      this.updateStatus("denied", "Obavijesti su odbačene")
    }
    
    this.updateStatus()
  }

  async enableNotifications() {
    if ('serviceWorker' in navigator && 'PushManager' in window) {
      try {
        const registration = await navigator.serviceWorker.ready
        const subscription = await registration.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: this.urlBase64ToUint8Array(this.vapidKeyValue)
        })

        // Send subscription to server
        await fetch('/push_subscriptions', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
          },
          body: JSON.stringify({
            subscription: subscription.toJSON()
          })
        })

        // Show success info
        if (this.hasAdditionalInfoTarget) {
          this.additionalInfoTarget.style.display = 'block'
        }
      } catch (error) {
        console.error('Error enabling notifications:', error)
        this.updateStatus("error", "Greška pri omogućavanju obavijesti")
      }
    }
  }

  updateStatus(status = null, message = null) {
    const permission = status || Notification.permission
    let statusText = message
    let statusClass = "bg-muted"
    let buttonVisible = true

    switch (permission) {
      case "granted":
        statusText = statusText || "Omogućene"
        statusClass = "bg-success"
        buttonVisible = false
        break
      case "denied":
        statusText = statusText || "Odbačene"
        statusClass = "bg-danger"
        buttonVisible = false
        break
      case "default":
        statusText = statusText || "Čeka dozvolu"
        statusClass = "bg-warning"
        break
      case "not-supported":
        statusClass = "bg-muted"
        buttonVisible = false
        break
      case "error":
        statusClass = "bg-danger"
        break
      default:
        statusText = statusText || "Provjera statusa..."
        statusClass = "bg-muted"
    }

    if (this.hasStatusTarget && statusText) {
      this.statusTarget.textContent = statusText
    }

    if (this.hasStatusDotTarget) {
      // Remove all status classes
      this.statusDotTarget.className = this.statusDotTarget.className.replace(/bg-\w+/g, '')
      this.statusDotTarget.classList.add('status-dot', statusClass)
    }

    if (this.hasEnableButtonTarget) {
      if (buttonVisible && permission !== "granted") {
        this.enableButtonTarget.style.display = 'flex'
        this.enableButtonTarget.disabled = false
        this.enableButtonTarget.innerHTML = `
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" 
               stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" 
               class="icon icon-tabler icons-tabler-outline icon-tabler-bell-plus me-2">
            <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
            <path d="M10 5a2 2 0 1 1 4 0a7 7 0 0 1 4 6v3a4 4 0 0 0 2 3h-16a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6"/>
            <path d="M9 17v1a3 3 0 0 0 6 0v-1"/>
            <path d="M15 6h6m-3 -3v6"/>
          </svg>
          Omogući obavijesti
        `
      } else {
        this.enableButtonTarget.style.display = 'none'
      }
    }
  }

  urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4)
    const base64 = (base64String + padding)
      .replace(/-/g, '+')
      .replace(/_/g, '/')

    const rawData = window.atob(base64)
    const outputArray = new Uint8Array(rawData.length)

    for (let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i)
    }
    return outputArray
  }
}
